import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// One Leads record: its fields, decisions or readings, and the owner's edit and pack review.
export const Route = createFileRoute('/_authed/leads/$type/$key')({
  component: lazyRouteComponent(
    () => import('../../../features/leads/screens.tsx'),
    'LeadsRecordRoute',
  ),
});
